const triggerSlider = function () {
    setSliderAt(6.2, 2);
};

export function setSliderAt(range, steps) {
    if ($('#sliderDots').length) {
        $('.grid-container-small .breadcrumb .b--list li a, .grid-container-small .breadcrumb .b--list li span').css('color', '#FFFFFF');
        $('head').append('<style>.grid-container-small .breadcrumb .b--list li a::after{border:solid #FFFFFF; border-width: 0 0.1rem 0.1rem 0;}</style>');
        $('.grid-container-small .breadcrumb.breadcrumb--mobile a::before, .grid-container-small .breadcrumb.breadcrumb--mobile  a').css('color', '#FFFFFF');

        let sliderDots = $('.dots-slider').children();

        for (let i = 0; i < 9; i++) {
            $(sliderDots[i]).css('backgroundColor','#661593');
        }
        for (let i = 0; i < range - 1; i++) {
            $(sliderDots[i]).css('backgroundColor','#fff');
        }
        range = range * 10;

        $(".steps-display").html(steps + ' / 3');
        $('.slider-step').css("background", 'linear-gradient(to right, #fff 0%, #fff ' + range + '%, #661593 ' + range + '%, #661593 100%)');
    }
}

$(document).ready(function () {
    triggerSlider();
});